import React from 'react';
import PropTypes from 'prop-types';
import { TextField } from '../../TextField/component';
import { TextArea } from '../../TextArea/component';

import './style.scss';

export class ImageDescriptionsSettings extends React.PureComponent {
  static propTypes = {
    className: PropTypes.string,

    altText: PropTypes.string,
    longDescription: PropTypes.string,

    altTextError: PropTypes.string,
    longDescriptionError: PropTypes.string,

    altTextOnChange: PropTypes.func.isRequired,
    longDescriptionOnChange: PropTypes.func.isRequired,
  };

  static defaultProps = {
    altText: '',
    longDescription: '',
    className: null,
    altTextError: null,
    longDescriptionError: null,
  };

  render() {
    const {
      className,
      altText,
      altTextOnChange,
      altTextError,
      longDescription,
      longDescriptionOnChange,
      longDescriptionError,
    } = this.props;

    return (
      <image-descriptions-settings class={className}>
        <TextField
          className="image-descriptions-settings-field"
          label="Alt text"
          type="text"
          value={altText}
          onValueChange={altTextOnChange}
          error={altTextError}
          maxLength="125"
          description="Provide a brief description for people who cannot see the image."
        />
        <TextArea
          className="image-descriptions-settings-field"
          label="Long description"
          value={longDescription}
          onValueChange={longDescriptionOnChange}
          error={longDescriptionError}
          description="Provide a description for complex images (e.g. graphs, maps, charts)."
        />
      </image-descriptions-settings>
    );
  }
}
